import { render, staticRenderFns } from "./StoreBase.vue?vue&type=template&id=4e5c0dba&"
import script from "./StoreBase.vue?vue&type=script&lang=js&"
export * from "./StoreBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports